<template>
	<v-row no-gutters align="center" justify="center" class="mb-3">
		<v-col cols="2">
			<template v-for="p in rigthPoints">
				<v-card
					v-if="p.selected"
					:key="p.name"
					class="mb-2 animated fadeIn"
					color="secondary"
				>
					<v-card-title class="pa-2 pb-0 text-body-1 primary--text"
						>{{ p.name }} -
						<span v-translate class="ml-1">Right</span></v-card-title
					>
					<v-card-text class="pa-0 pb-2">
						<v-textarea
							v-model="p.note"
							class="px-2 text-caption"
							filled
							dense
							no-resize
							:height="100"
							:disabled="results"
							placeholder="..."
							hide-details
						/>
						<v-select
							v-model="p.types"
							item-value="id"
							item-text="name"
							:items="types"
							:label="$gettext('Types')"
							:disabled="results"
							class="px-2 mt-1 text-caption"
							solo
							dense
							flat
							hide-details
							multiple
							single-line
						></v-select>
					</v-card-text>
				</v-card>
			</template>
		</v-col>
		<v-col cols="8" class="px-5">
			<v-row no-gutters align="center" justify="center">
				<svg
					xmlns:dc="http://purl.org/dc/elements/1.1/"
					xmlns:cc="http://creativecommons.org/ns#"
					xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
					xmlns:svg="http://www.w3.org/2000/svg"
					xmlns="http://www.w3.org/2000/svg"
					xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
					xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
					sodipodi:docname="pulse.svg"
					inkscape:version="1.0rc1 (09960d6, 2020-04-09)"
					id="svg8"
					version="1.1"
					height="550"
					viewBox="0 0 297 210"
				>
					<defs id="defs2" />
					<sodipodi:namedview
						inkscape:window-maximized="0"
						inkscape:window-y="23"
						inkscape:window-x="0"
						inkscape:window-height="755"
						inkscape:window-width="1252"
						showgrid="false"
						inkscape:document-rotation="0"
						inkscape:current-layer="layer1"
						inkscape:document-units="mm"
						inkscape:cy="165.71429"
						inkscape:cx="875.71429"
						inkscape:zoom="0.35"
						inkscape:pageshadow="2"
						inkscape:pageopacity="0.0"
						borderopacity="1.0"
						bordercolor="#666666"
						pagecolor="#ffffff"
						id="base"
					/>
					<metadata id="metadata5">
						<rdf:RDF>
							<cc:Work rdf:about="">
								<dc:format>image/svg+xml</dc:format>
								<dc:type
									rdf:resource="http://purl.org/dc/dcmitype/StillImage"
								/>
								<dc:title></dc:title>
							</cc:Work>
						</rdf:RDF>
					</metadata>
					<g id="layer1" inkscape:groupmode="layer" inkscape:label="Layer 1">
						<path
							style="
								fill: none;
								stroke: #000000;
								stroke-width: 0.264583px;
								stroke-linecap: butt;
								stroke-linejoin: miter;
								stroke-opacity: 1;
							"
							d="M 173.93009,45.276442 V 167.74072 H 194.34081 V 168.49668 V 168.49668"
							id="path929-8"
							inkscape:connector-curvature="0"
							:style="
								allLeft.selected
									? 'stroke: var(--v-primary-base);stroke-width:2px'
									: ''
							"
						/>
						<path
							inkscape:connector-curvature="0"
							id="path929"
							d="M 103.86786,44.60119 V 167.06547 H 83.457142 V 167.82143 V 167.82143"
							style="
								fill: none;
								stroke: #000000;
								stroke-width: 0.264583px;
								stroke-linecap: butt;
								stroke-linejoin: miter;
								stroke-opacity: 1;
							"
							:style="
								allRight.selected
									? 'stroke: var(--v-primary-base);stroke-width:2px'
									: ''
							"
						/>
						<circle
							r="12.095239"
							cy="56.69643"
							cx="103.52081"
							id="path10"
							style="
								fill: #ffffff;
								fill-rule: evenodd;
								stroke: #000000;
								stroke-width: 0.322792;
								stroke-linecap: round;
								stroke-linejoin: round;
								stroke-opacity: 1;
								paint-order: markers stroke fill;
								stop-color: #000000;
								fill-opacity: 1;
								cursor: pointer;
							"
							:style="
								chiRight.selected
									? 'fill: var(--v-primary-base);stroke-width:2px'
									: ''
							"
							@click="clickPoint(chiRight)"
						/>
						<circle
							style="
								fill: #ffffff;
								fill-rule: evenodd;
								stroke: #000000;
								stroke-width: 0.322792;
								stroke-linecap: round;
								stroke-linejoin: round;
								stroke-opacity: 1;
								paint-order: markers stroke fill;
								stop-color: #000000;
								fill-opacity: 1;
								cursor: pointer;
							"
							id="path10-4"
							cx="103.52081"
							cy="98.273804"
							r="12.095239"
							:style="
								guanRight.selected
									? 'fill: var(--v-primary-base);stroke-width:2px'
									: ''
							"
							@click="clickPoint(guanRight)"
						/>
						<circle
							style="
								fill: #ffffff;
								fill-rule: evenodd;
								stroke: #000000;
								stroke-width: 0.322792;
								stroke-linecap: round;
								stroke-linejoin: round;
								stroke-opacity: 1;
								paint-order: markers stroke fill;
								stop-color: #000000;
								fill-opacity: 1;
								cursor: pointer;
							"
							id="path10-8"
							cx="103.52081"
							cy="139.85118"
							r="12.095239"
							:style="
								tsunRight.selected
									? 'fill: var(--v-primary-base);stroke-width:2px'
									: ''
							"
							@click="clickPoint(tsunRight)"
						/>
						<circle
							style="
								fill: #ffffff;
								fill-rule: evenodd;
								stroke: #000000;
								stroke-width: 0.322792;
								stroke-linecap: round;
								stroke-linejoin: round;
								stroke-opacity: 1;
								paint-order: markers stroke fill;
								stop-color: #000000;
								fill-opacity: 1;
								cursor: pointer;
							"
							id="path10-3"
							cx="173.79341"
							cy="56.69643"
							r="12.095239"
							:style="
								chiLeft.selected
									? 'fill: var(--v-primary-base);stroke-width:2px'
									: ''
							"
							@click="clickPoint(chiLeft)"
						/>
						<circle
							r="12.095239"
							cy="98.273804"
							cx="173.79341"
							id="path10-4-9"
							style="
								fill: #ffffff;
								fill-rule: evenodd;
								stroke: #000000;
								stroke-width: 0.322792;
								stroke-linecap: round;
								stroke-linejoin: round;
								stroke-opacity: 1;
								paint-order: markers stroke fill;
								stop-color: #000000;
								fill-opacity: 1;
								cursor: pointer;
							"
							:style="
								guanLeft.selected
									? 'fill: var(--v-primary-base);stroke-width:2px'
									: ''
							"
							@click="clickPoint(guanLeft)"
						/>
						<circle
							r="12.095239"
							cy="139.85118"
							cx="173.79341"
							id="path10-8-0"
							style="
								fill: #ffffff;
								fill-rule: evenodd;
								stroke: #000000;
								stroke-width: 0.322792;
								stroke-linecap: round;
								stroke-linejoin: round;
								stroke-opacity: 1;
								paint-order: markers stroke fill;
								stop-color: #000000;
								fill-opacity: 1;
								cursor: pointer;
							"
							:style="
								tsunLeft.selected
									? 'fill: var(--v-primary-base);stroke-width:2px'
									: ''
							"
							@click="clickPoint(tsunLeft)"
						/>
						<text
							id="text879"
							y="61.232143"
							x="130.93553"
							style="
								font-style: normal;
								font-weight: normal;
								font-size: 10.5833px;
								line-height: 1.25;
								font-family: sans-serif;
								fill: #000000;
								fill-opacity: 1;
								stroke: none;
								stroke-width: 0.264583;
							"
							xml:space="preserve"
						>
							<tspan
								style="stroke-width: 0.264583"
								y="61.232143"
								x="130.93553"
								id="tspan877"
								sodipodi:role="line"
							>
								Chi
							</tspan>
						</text>
						<text
							xml:space="preserve"
							style="
								font-style: normal;
								font-weight: normal;
								font-size: 10.5833px;
								line-height: 1.25;
								font-family: sans-serif;
								fill: #000000;
								fill-opacity: 1;
								stroke: none;
								stroke-width: 0.264583;
							"
							x="125.45785"
							y="101.46851"
							id="text879-0"
						>
							<tspan
								sodipodi:role="line"
								id="tspan877-4"
								x="125.45785"
								y="101.46851"
								style="stroke-width: 0.264583"
							>
								Guan
							</tspan>
						</text>
						<text
							id="text901"
							y="143.63095"
							x="127.01588"
							style="
								font-style: normal;
								font-weight: normal;
								font-size: 10.5833px;
								line-height: 1.25;
								font-family: sans-serif;
								fill: #000000;
								fill-opacity: 1;
								stroke: none;
								stroke-width: 0.264583;
							"
							xml:space="preserve"
						>
							<tspan
								style="stroke-width: 0.264583"
								y="143.63095"
								x="127.01588"
								id="tspan899"
								sodipodi:role="line"
							>
								Tsun
							</tspan>
						</text>
						<text
							id="text905"
							y="30.238092"
							x="96.005951"
							style="
								font-style: normal;
								font-weight: normal;
								font-size: 10.5833px;
								line-height: 1.25;
								font-family: sans-serif;
								fill: #000000;
								fill-opacity: 1;
								stroke: none;
								stroke-width: 0.264583;
							"
							xml:space="preserve"
						>
							<tspan
								style="stroke-width: 0.264583"
								y="30.238092"
								x="96.005951"
								id="tspan903"
								sodipodi:role="line"
							>
								Dir.
							</tspan>
						</text>
						<text
							id="text909"
							y="29.482143"
							x="164.79762"
							style="
								font-style: normal;
								font-weight: normal;
								font-size: 10.5833px;
								line-height: 1.25;
								font-family: sans-serif;
								fill: #000000;
								fill-opacity: 1;
								stroke: none;
								stroke-width: 0.264583;
							"
							xml:space="preserve"
						>
							<tspan
								style="stroke-width: 0.264583"
								y="29.482143"
								x="164.79762"
								id="tspan907"
								sodipodi:role="line"
							>
								Esq.
							</tspan>
						</text>
						<rect
							y="157.99405"
							x="67.279762"
							height="18.142857"
							width="18.142857"
							id="rect931"
							style="
								fill: #ffffff;
								fill-opacity: 1;
								fill-rule: evenodd;
								stroke: #000000;
								stroke-width: 0.322792;
								stroke-linecap: round;
								stroke-linejoin: round;
								stroke-opacity: 1;
								paint-order: markers stroke fill;
								stop-color: #000000;
								cursor: pointer;
							"
							@click="clickSelectAll(allRight)"
							:style="
								allRight.selected
									? 'stroke: var(--v-primary-base);stroke-width:2px'
									: ''
							"
						/>
						<rect
							transform="scale(-1,1)"
							style="
								fill: #ffffff;
								fill-opacity: 1;
								fill-rule: evenodd;
								stroke: #000000;
								stroke-width: 0.322792;
								stroke-linecap: round;
								stroke-linejoin: round;
								stroke-opacity: 1;
								paint-order: markers stroke fill;
								stop-color: #000000;
								cursor: pointer;
							"
							id="rect931-8"
							width="18.142857"
							height="18.142857"
							x="-210.51819"
							y="158.6693"
							@click="clickSelectAll(allLeft)"
							:style="
								allLeft.selected
									? 'stroke: var(--v-primary-base);stroke-width:2px'
									: ''
							"
						/>
					</g>
				</svg>
			</v-row>
			<v-row v-if="allRight || allLeft" no-gutters>
				<v-col cols="5">
					<v-card
						v-if="allRight.selected"
						class="mb-2 animated fadeIn"
						color="secondary"
					>
						<v-card-title class="pa-2 pb-0 text-body-1 primary--text"
							><span v-translate>Right</span></v-card-title
						>
						<v-card-text class="pa-0 pb-2">
							<v-select
								v-model="allRightTypes"
								:items="types"
								item-value="id"
								item-text="name"
								:label="$gettext('Types')"
								:disabled="results"
								class="px-2 mt-1 text-caption"
								solo
								dense
								flat
								hide-details
								multiple
								single-line
							></v-select>
						</v-card-text>
					</v-card>
				</v-col>
				<v-col> </v-col>
				<v-col cols="5">
					<v-card
						v-if="allLeft.selected"
						class="mb-2 animated fadeIn"
						color="secondary"
					>
						<v-card-title class="pa-2 pb-0 text-body-1 primary--text"
							><span v-translate>Left</span></v-card-title
						>
						<v-card-text class="pa-0 pb-2">
							<v-select
								v-model="allLeftTypes"
								:items="types"
								item-value="id"
								item-text="name"
								:label="$gettext('Types')"
								:disabled="results"
								class="px-2 mt-1 text-caption"
								solo
								dense
								flat
								hide-details
								multiple
								single-line
							></v-select>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-col>
		<v-col cols="2">
			<template v-for="p in leftPoints">
				<v-card
					v-if="p.selected"
					:key="p.name"
					class="mb-2 animated fadeIn"
					color="secondary"
				>
					<v-card-title class="pa-2 pb-0 text-body-1 primary--text"
						>{{ p.name }} -
						<span v-translate class="ml-1">Left</span></v-card-title
					>
					<v-card-text class="pa-0 pb-2">
						<v-textarea
							v-model="p.note"
							class="px-2 text-caption"
							filled
							:height="100"
							no-resize
							:disabled="results"
							placeholder="..."
							hide-details
						/>
						<v-select
							v-model="p.types"
							:items="types"
							:disabled="results"
							item-value="id"
							item-text="name"
							:label="$gettext('Types')"
							class="px-2 mt-1 text-caption"
							solo
							dense
							flat
							hide-details
							multiple
							single-line
						></v-select>
					</v-card-text>
				</v-card>
			</template>
		</v-col>
	</v-row>
</template>

<script>
export default {
  name: "TCMPulseDiagram",
  props: ["test", "results", "edit", "types"],
  data: () => ({
		chiRight: {
			name: "Chi",
			note: "",
			types: [],
			selected: false
		},
		guanRight: {
			name: "Guan",
			note: "",
			types: [],
			selected: false
		},
		tsunRight: {
			name: "Tsun",
			note: "",
			types: [],
			selected: false
		},
		chiLeft: {
			name: "Chi",
			note: "",
			types: [],
			selected: false
		},
		guanLeft: {
			name: "Guan",
			note: "",
			types: [],
			selected: false
		},
		tsunLeft: {
			name: "Tsun",
			note: "",
			types: [],
			selected: false
		},
		allRight: {
			types: [],
			selected: false
		},
		allLeft: {
			types: [],
			selected: false
		}
  }),
  computed: {
		rigthPoints() {
			return [this.chiRight, this.guanRight, this.tsunRight];
		},
		leftPoints() {
			return [this.chiLeft, this.guanLeft, this.tsunLeft];
		},
		allRightTypes: {
			get() {
				let rightPoints = [this.chiRight, this.guanRight, this.tsunRight];
				return rightPoints.shift().types.filter(function(v) {
					return rightPoints.every(function(a) {
						return a.types.indexOf(v) !== -1;
					});
				});
			},
			set(types) {
				let selectedType = types.filter(t => !this.allRightTypes.includes(t));
				let removedType = this.allRightTypes.filter(t => !types.includes(t));
				
				if(selectedType.length > 0) this.rigthPoints.forEach(p => {
					let index = p.types.indexOf(selectedType[0]);
					if (index == -1) {
						p.types.push(selectedType[0]);
					}
				});
				if(removedType.length > 0) this.rigthPoints.forEach(p => {
					let index = p.types.indexOf(removedType[0]);
					if (index > -1) {
						p.types.splice(index, 1);
					}
				});
			}
		},
		allLeftTypes: {
			get() {
				let leftPoints = [this.chiLeft, this.guanLeft, this.tsunLeft];
				return leftPoints.shift().types.filter(function(v) {
					return leftPoints.every(function(a) {
						return a.types.indexOf(v) !== -1;
					});
				});
			},
			set(types) {
				let selectedType = types.filter(t => !this.allLeftTypes.includes(t));
				let removedType = this.allLeftTypes.filter(t => !types.includes(t));
				
				if(selectedType.length > 0) this.leftPoints.forEach(p => {
					let index = p.types.indexOf(selectedType[0]);
					if (index == -1) {
						p.types.push(selectedType[0]);
					}
				});
				if(removedType.length > 0) this.leftPoints.forEach(p => {
					let index = p.types.indexOf(removedType[0]);
					if (index > -1) {
						p.types.splice(index, 1);
					}
				});
			}
		}
  },
  methods: {
		getForm() {
			this.test.data.chiR.note = this.chiRight.note;
			this.test.data.chiR.types = this.chiRight.types;
			this.test.data.chiL.note = this.chiLeft.note;
			this.test.data.chiL.types = this.chiLeft.types;

			this.test.data.guanR.note = this.guanRight.note;
			this.test.data.guanR.types = this.guanRight.types;
			this.test.data.guanL.note = this.guanLeft.note;
			this.test.data.guanL.types = this.guanLeft.types;

			this.test.data.tsunR.note = this.tsunRight.note;
			this.test.data.tsunR.types = this.tsunRight.types;
			this.test.data.tsunL.note = this.tsunLeft.note;
			this.test.data.tsunL.types = this.tsunLeft.types;

			this.test.data.allR.types = this.allRight.types;
			this.test.data.allL.types = this.allLeft.types;
			
			const formData = new FormData();
			formData.append("info", JSON.stringify(this.test.data));
			formData.append("kind", "pulse");
      formData.append("module", "tcm");

			return formData;
		},
		clickPoint(point) {
			point.selected = !point.selected;
		},
		clickSelectAll(side) {
			side.selected = !side.selected;
		}
	},
	mounted() {
		this.chiRight.note = this.test.data.chiR.note;
		this.chiRight.types = this.test.data.chiR.types;
		this.chiLeft.note = this.test.data.chiL.note;
		this.chiLeft.types = this.test.data.chiL.types;

		this.guanRight.note = this.test.data.guanR.note;
		this.guanRight.types = this.test.data.guanR.types;
		this.guanLeft.note = this.test.data.guanL.note;
		this.guanLeft.types = this.test.data.guanL.types;

		this.tsunRight.note = this.test.data.tsunR.note;
		this.tsunRight.types = this.test.data.tsunR.types;
		this.tsunLeft.note = this.test.data.tsunL.note;
		this.tsunLeft.types = this.test.data.tsunL.types;

		this.allRight.types = this.test.data.allR.types;
		this.allLeft.types = this.test.data.allL.types;
		
		if(this.results || this.edit) {
			if(this.chiRight.note != "" || this.chiRight.types.length > 0) this.chiRight.selected = true;
			if(this.chiLeft.note != "" || this.chiLeft.types.length > 0) this.chiLeft.selected = true;

			if(this.guanRight.note != "" || this.guanRight.types.length > 0) this.guanRight.selected = true;
			if(this.guanLeft.note != "" || this.guanLeft.types.length > 0) this.guanLeft.selected = true;

			if(this.tsunRight.note != "" || this.tsunRight.types.length > 0) this.tsunRight.selected = true;
			if(this.tsunLeft.note != "" || this.tsunLeft.types.length > 0) this.tsunLeft.selected = true;

			if(this.allRight.types.length > 0 || this.allRightTypes.length > 0) this.allRight.selected = true;
			if(this.allLeft.types.length > 0 || this.allLeftTypes.length > 0) this.allLeft.selected = true;
		}
	}
}
</script>